import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie';
import { CookieConsentDialogComponent } from './templates/dialogs/cookie-consent-dialog/cookie-consent-dialog.component';
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from './views/home/auth.service';
import { UserActivityService } from './services/user-activity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'productdev-edge-angular';

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private userActivityService: UserActivityService,
    private dialog: MatDialog,
    private cookieService: CookieService
  ) {
    this.translate.addLangs(['de', 'en', 'es', 'fr']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    this.checkAuthenticationAndStartMonitoring();
    this.openCookieConsentIfNeeded();
  }

  ngOnDestroy(): void {
  }

  private checkAuthenticationAndStartMonitoring(): void {
    if (this.authService.isAuthenticated('brand')) {
      // Start activity monitoring for authenticated users
    }
  }

  private openCookieConsentIfNeeded(): void {
    // Check if user has already consented (using static method from dialog component)
    if (CookieConsentDialogComponent.hasUserConsented()) {
      return;
    }

    const dialogRef = this.dialog.open(CookieConsentDialogComponent, {
      width: '100%',
      maxWidth: '100%',
      hasBackdrop: false,
      disableClose: true,
      autoFocus: false,
      panelClass: 'cookie-consent-dialog-panel',
      position: { bottom: '0' }
    });

    dialogRef.afterClosed().subscribe((choice: 'all' | 'essential' | undefined) => {
      if (!choice) {
        return;
      }

      // The choice is already saved in localStorage by the dialog component
      // Optionally, you can also save to cookies if needed for server-side access
      const expiry = new Date();
      expiry.setFullYear(expiry.getFullYear() + 1);
      this.cookieService.put('cookie_consent', choice, {
        expires: expiry,
        sameSite: 'lax'
      });
    });
  }
}